import * as React from 'react';

function SvgBrandLogoDark(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 167 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#BrandLogoDark_svg__clip0)">
        <path
          d="M27.344 16.729L21.18.265h3.617l4.257 11.906L33.32.265h3.54L30.67 16.728h-3.326zM66.16 10.588v6.14h-3.405V.265h6.776c3.456 0 5.762 1.849 5.762 5.23 0 2.624-1.447 4.291-3.753 4.854l4.34 6.38h-3.856l-4.07-6.141H66.16zm0-2.812h3.158c1.712 0 2.597-.911 2.597-2.282 0-1.396-.885-2.307-2.597-2.307h-3.159v4.589zM83.2.265h5.813c4.98 0 8.12 3.219 8.12 8.229 0 5.015-3.133 8.228-8.12 8.228H83.2V.265zm5.678 13.432c3.133 0 4.85-2.01 4.85-5.203 0-3.22-1.71-5.23-4.85-5.23h-2.28v10.427h2.28v.006zM129.153 12.036c.459 1.448 1.66 2.12 3.269 2.12 1.66 0 2.758-.75 2.758-2.062 0-.99-.588-1.526-2.009-1.849l-2.946-.672c-2.357-.537-4.179-1.797-4.179-4.505 0-2.974 2.468-5.068 5.923-5.068 3.753 0 5.924 1.984 6.46 4.77h-3.404c-.375-1.099-1.311-1.958-3.03-1.958-1.557 0-2.596.75-2.596 1.932 0 .938.613 1.5 1.847 1.797l3.004.699c2.68.614 4.315 2.146 4.315 4.64 0 3.194-2.629 5.12-6.111 5.12-3.669 0-6.272-1.823-6.834-4.958h3.533v-.006zM157.259.265v3.006h-7.797v3.594h5.814v2.921h-5.814v3.917h7.797v3.032h-11.175V.265h11.175zM54.752.265v3.006h-7.797v3.594h5.814v2.921h-5.814v3.917h7.797v3.032H43.577V.265h11.175zM8.281.24a8.295 8.295 0 018.307 8.331c0 4.615-3.688 8.287-8.307 8.287C3.663 16.858 0 13.186 0 8.57S3.669.24 8.281.24zm0 13.263c2.713 0 4.955-2.217 4.955-4.932 0-2.715-2.242-4.977-4.955-4.977S3.353 5.856 3.353 8.57c0 2.708 2.215 4.932 4.928 4.932zM110.982.24a8.295 8.295 0 018.307 8.331c0 4.615-3.688 8.287-8.307 8.287a8.235 8.235 0 01-8.281-8.287c0-4.615 3.663-8.332 8.281-8.332zm0 13.263c2.713 0 4.955-2.217 4.955-4.932 0-2.715-2.242-4.977-4.955-4.977s-4.928 2.262-4.928 4.977c-.007 2.708 2.215 4.932 4.928 4.932z"
          fill="#2D3339"
        />
        <path
          d="M165.405 16.89a1.596 1.596 0 10-.002-3.191 1.596 1.596 0 00.002 3.191z"
          fill="#30373D"
        />
      </g>
      <defs>
        <clipPath id="BrandLogoDark_svg__clip0">
          <path fill="#fff" d="M0 0h167v17H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgBrandLogoDark;
